import { render, staticRenderFns } from "./BasePopup.vue?vue&type=template&id=0d27a4f1&"
import script from "./BasePopup.vue?vue&type=script&lang=js&"
export * from "./BasePopup.vue?vue&type=script&lang=js&"
import style0 from "./BasePopup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp7.4.1\\htdocs\\e2e-invoicing\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d27a4f1')) {
      api.createRecord('0d27a4f1', component.options)
    } else {
      api.reload('0d27a4f1', component.options)
    }
    module.hot.accept("./BasePopup.vue?vue&type=template&id=0d27a4f1&", function () {
      api.rerender('0d27a4f1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/base/popup/BasePopup.vue"
export default component.exports